import React from 'react';
import ListBase from './ListBase';

class EYList extends React.Component {
  getStyles = type => {
    switch (type) {
      case 'secondary': {
        return {
          root: {
            padding: 0,
          },
        };
      }
      default: {
        return {};
      }
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <ListBase styles={styles} {...otherProps} />;
  }
}

export default EYList;
